import { mountVueComponent } from '@/lib/mount-vue-component';

export default function () {
	import('@/modules/integrations/component/PrismaticMarketplace').then((prismaticMarketplace) => {
		mountVueComponent('prismatic-marketplace', prismaticMarketplace, true);
	});
}
